// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../../../graphql/api/cms/link.fragment.generated';
export const ComponentButtonFragmentDoc = gql`
    fragment componentButton on ComponentButton {
  __typename
  text
  link {
    ...link
  }
  alignment
  style {
    type
    size
    color
    width
    linkSize
    topSpacing
    bottomSpacing
  }
  icon {
    position
    icon
  }
  eventTracking {
    event
    category
    action
    label
  }
}
    ${LinkFragmentDoc}`;